// extracted by mini-css-extract-plugin
export default {"page_centered_content":"styles_page_centered_content__tNhwA"};